import React from 'react'
import PropTypes from 'prop-types'
import { StyledCardHeader, StyledCardBody } from './StyledCard'

const Card = ({ label, children, height, HeaderComponent = StyledCardHeader, BodyComponent = StyledCardBody, noDataText, styleInverted, ...props }) => {
	return(
		<div {...props}>
			{label && 
				<HeaderComponent>
					{label}
				</HeaderComponent>
			}
			<BodyComponent style={{ height }} styleInverted={styleInverted}>
				{children ? children : noDataText}
			</BodyComponent>
		</div>
	)
}

Card.propTypes = {
	label: PropTypes.string,
	height: PropTypes.number,
	HeaderComponent: PropTypes.PropTypes.oneOfType([ PropTypes.element, PropTypes.func ]),
	BodyComponent: PropTypes.PropTypes.oneOfType([ PropTypes.element, PropTypes.func ]),
	noDataText: PropTypes.string
}

export default Card
